import type { Tabulator } from "tabulator-tables";
import Observable from "../state/Observable";

export type ViewState = "map" | "table";

export type ViewStateObservable = Observable<ViewState>;

function getViewIcons(): {
  tableIcon: HTMLButtonElement;
  mapIcon: HTMLButtonElement;
} | null {
  const tableIcon = document.querySelector<HTMLButtonElement>(
    ".header-table-icon-container",
  );
  const mapIcon = document.querySelector<HTMLButtonElement>(
    ".header-map-icon-container",
  );
  if (!mapIcon || !tableIcon) return null;
  return { tableIcon, mapIcon };
}

function updateUI(table: Tabulator, state: ViewState): void {
  const viewIcons = getViewIcons();
  const tableView = document.querySelector<HTMLElement>("#table-view");
  const mapView = document.querySelector<HTMLElement>("#map");
  const mapCounter = document.querySelector<HTMLElement>("#map-counter");
  const prnLogo = document.querySelector<HTMLElement>(".prn-logo-map");
  if (!viewIcons || !tableView || !mapView || !mapCounter || !prnLogo) return;
  const { tableIcon, mapIcon } = viewIcons;

  // mapCounter/prnLogo `.hidden` is reset here on every view switch, so
  // hideMapOverlays.ts must use `style.display` instead of `.hidden` to hide
  // them permanently — don't "fix" that to use `.hidden` for consistency.
  if (state === "map") {
    tableIcon.style.display = "inline-flex";
    mapIcon.style.display = "none";
    tableView.hidden = true;
    mapView.hidden = false;
    mapCounter.hidden = false;
    prnLogo.hidden = false;
  } else {
    tableIcon.style.display = "none";
    mapIcon.style.display = "inline-flex";
    tableView.hidden = false;
    mapView.hidden = true;
    mapCounter.hidden = true;
    prnLogo.hidden = true;
    table.redraw();
  }
}

function updateOnIconClick(observable: ViewStateObservable): void {
  const viewIcons = getViewIcons();
  if (!viewIcons) return;
  const { tableIcon, mapIcon } = viewIcons;

  tableIcon.addEventListener("click", () => observable.setValue("table"));
  mapIcon.addEventListener("click", () => observable.setValue("map"));
}

export function initViewToggle(): ViewStateObservable {
  const viewToggle = new Observable<ViewState>("view toggle", "map");
  updateOnIconClick(viewToggle);
  return viewToggle;
}

export function addViewToggleSubscribers(
  observable: ViewStateObservable,
  table: Tabulator,
): void {
  observable.subscribe("switch app view", (state) => updateUI(table, state));
}
